import { render } from "./TicketPrintPreviewForAgent.vue?vue&type=template&id=08ebf974&scoped=true"
import script from "./TicketPrintPreviewForAgent.vue?vue&type=script&lang=js"
export * from "./TicketPrintPreviewForAgent.vue?vue&type=script&lang=js"

import "./TicketPrintPreviewForAgent.vue?vue&type=style&index=0&id=08ebf974&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ebf974"]])

export default __exports__